import { startHTTPRequest, fetchMatchCodeFromString } from '../../../assets/js/common';
import { CFG_WIDGET_API_BASE, SPORT_LIST, CFG_MODULES, CFG_NODE_API_BASE } from '../../../assets/js/config';
import { SET_MATCH_TIPS_LISTING } from '../../types';

const getSeparatedLists = (matches) => {
    return {
        featuredList: matches.slice(0, 1),
        relatedList: matches.slice(1, matches.length),
    }
};

const setFirstPage = (state, routeParams) => {
    let pageFromUrl = routeParams.page_number;
    if (pageFromUrl && !isNaN(pageFromUrl) && (+pageFromUrl > state.pagenumber)) {
        state.firstPage = +pageFromUrl;
        state.pagenumber = +pageFromUrl;
    } else {
        state.firstPage = 1;
    }

    if (routeParams.series_slug) {
        if (routeParams.series_slug.indexOf('-series-') > -1) {
            state.selectedSport = null;
            let seriesCode = fetchMatchCodeFromString(routeParams.series_slug);
            state.selected_series = seriesCode;
        } else {
            state.selected_series = -1;
            let sport = SPORT_LIST.find(s => s.name.toLocaleLowerCase() === routeParams.series_slug.toLocaleLowerCase())
            state.selectedSport = sport;
        }
    }
}

const getSeriesList = (data, sportid, isMatchTipsPage, seriesObj) => {
    let { categories, matches } = data;
    let seriesArr = [{
        "category_id": 0,
        "category_name": "All Series",
        "category_order": 0,
        "sport_id": 0,
        "series_code": "-1",
        "series_name": "All Series",
        "sport_name": "All"
    }];
    if (seriesObj && seriesObj.seriesId && seriesObj.seriesId != -1) {
        let seriesAvailable = matches.find(m => seriesObj.seriesId == m.series_code);
        if (!seriesAvailable) {
            /* if match not available in getMatches api then we consider it cricket series by default */
            let trimmedSeriesSlug = seriesObj.seriesName.replace(`-series-${seriesObj.seriesId}`, '');
            let sportInSlug = trimmedSeriesSlug.split('-')[0];
            let isSportAvailable = SPORT_LIST.find(s => s.name.toLocaleLowerCase() == sportInSlug.toLocaleLowerCase());
            if(isSportAvailable) {
                trimmedSeriesSlug = trimmedSeriesSlug.replace(`${sportInSlug}-`, '');
            }
            let sName = trimmedSeriesSlug.replace(/-/g, ' ');
            seriesArr.push({
                "category_id": 0,
                "category_name": sName,
                "category_order": 0,
                "sport_id": 0,
                "series_code": seriesObj.seriesId,
                "series_name": sName,
                "sport_name": null,
                "disabled": true
            })
        }
    }
    categories.forEach(function (c) {
        let obj = { ...c };
        let matchFromCat = matches.find(m => obj.category_id === m.category_id);
        if (matchFromCat && (!sportid || (sportid && sportid == matchFromCat.sport_id))) {
            if (/* isMatchTipsPage &&  */matchFromCat.sport_id == 2) {
                return false;
            }
            obj.series_code = matchFromCat.series_code;
            obj.series_name = matchFromCat.series_name;
            obj.sport_id = matchFromCat.sport_id;
            obj.sport_name = matchFromCat.sport_name;
            seriesArr.push(obj);
        }
    })
    return seriesArr;
}

const getcurrentSeriesObj = (state) => {
    if (state.selected_series && state.selected_series != -1) {
        return state.series_list.find(s => s.series_code === state.selected_series);
    } else {
        return null;
    }
}

const serieslist = {
    namespaced: true,
    state: () => ((typeof window !== "undefined" && window.__ROI_STATE_DATA__ && window.__ROI_STATE_DATA__.serieslist) ? window.__ROI_STATE_DATA__.serieslist : {
        contests_updated: false,
        listing_store_filled: false,
        module: null,
        first_match: null,
        rest_matches: [],
        no_match_tips_list: false,
        selectedSport: null,
        firstPage: null, // update this number from url on page load
        pagenumber: 1,
        itemnumber: 19, // this is the item count for page!=1
        pagesize: 19, // this is the item count for page==1
        totalCount: 0,
        isLoadMoreDisabled: false,
        selected_series: -1,
        series_list: []
    }),
    mutations: {
        [SET_MATCH_TIPS_LISTING]: (state, payload) => {
            let { count, matches, isMobile } = payload;
            let { pagenumber, firstPage } = state;
            if (count) {
                state.totalCount = count;
            }

            if (isMobile) {
                state.first_match = null;
                state.rest_matches = matches;
            } else {
                let { featuredList, relatedList } = getSeparatedLists(matches);
                if (featuredList && featuredList.length) {
                    state.first_match = featuredList[0];
                }
                state.rest_matches = relatedList;
            }

            state.isLoadMoreDisabled = false;

            if (!state.no_match_tips_list) {
                if (pagenumber === firstPage && !matches.length) {
                    state.no_match_tips_list = true;
                }
            }
            state.listing_store_filled = true;
        }
    },
    actions: {
        fetchMatchData: ({ state, rootState }) => {
            let { route } = rootState;
            if (!state.firstPage) {
                route.params && setFirstPage(state, route.params);
            }
            let actionData = {
                method: "GET",
                url: `${CFG_WIDGET_API_BASE}api/App/GetMatches`,
                headers: {
                    "content-type": "application/json",
                    "accept": "*/*",
                },
                params: {},
                can_append: false,
                addAuthorization: false
            };

            return startHTTPRequest(actionData)
                .then((res) => {
                    let sportId = null, isMatchTipsPage = false;
                    if (route) {
                        if (route.params && route.params.series_slug) {
                            let sport = SPORT_LIST.find(s => s.name.toLocaleLowerCase() === route.params.series_slug.toLocaleLowerCase());
                            if (sport && sport.id) {
                                sportId = sport.id;
                            }
                        }

                        /* remove football series from matchtips page */
                        let MatchTipsUrlKey = CFG_MODULES.MATCH_INFO.route;
                        isMatchTipsPage = route.path && route.path.includes(MatchTipsUrlKey.replace(/\//g, ''));
                        if (isMatchTipsPage) {
                            sportId = 1;
                        }
                    }
                    state.series_list = getSeriesList(res, sportId, isMatchTipsPage, {
                        seriesId: state.selected_series,
                        seriesName: route.params.series_slug
                    });
                })
                .catch((e) => {
                    console.log(e);
                    console.log(e.toString());
                });
        },
        fetchHtohListing: ({ state, rootState, commit }) => {
            let { route } = rootState;
            if (state.isLoadMoreDisabled) return;
            state.isLoadMoreDisabled = true;
            let clearData = false;
            let teamHtohUrlKey = CFG_MODULES.TEAM_HTOH.route;
            let playerHtohUrlKey = CFG_MODULES.PLAYER_HTOH.route;
            let entity = "";
            if(route.path && route.path.includes(teamHtohUrlKey.replace(/\//g, ''))) {
                entity = 38291;
            } else if(route.path && route.path.includes(playerHtohUrlKey.replace(/\//g, ''))) {
                entity = 38691;
            }
            
            let apiParams = {
                entities: entity,
                source_type: 6,
                series_id: state.selected_series,
                page: state.pagenumber,
                item: state.itemnumber,
                page1: state.pagesize
            }
            return startHTTPRequest({
                method: "GET",
                url: `${CFG_NODE_API_BASE}series-htoh/get-series-data`,
                params: apiParams,
                can_append: false
            })
                .then((res) => {
                    let {items, count} = (res && res.data) || {};
                    if (clearData) {
                        commit(SET_MATCH_TIPS_LISTING, {
                            count: 0,
                            matches: [],
                            isMobile: rootState.ismobile
                        });
                    } else {
                        commit(SET_MATCH_TIPS_LISTING, {
                            count: (count || 0),
                            matches: (items || []),
                            isMobile: rootState.ismobile
                        });
                    }
                })
                .catch((e) => {
                    commit(SET_MATCH_TIPS_LISTING, {
                        count: 0,
                        matches: [],
                        isMobile: rootState.ismobile
                    });
                    console.log(e);
                    console.log(e.toString());
                });
        },
        fetchMatchTipsListing: ({ state, rootState, commit }) => {
            let { route } = rootState;
            if (state.isLoadMoreDisabled) return;
            state.isLoadMoreDisabled = true;
            let apiParams = {
                pagenumber: state.pagenumber,
                itemnumber: state.itemnumber,
                pagesize: state.pagesize,
            }
            if (state.selectedSport) {
                apiParams.sport_id = state.selectedSport.id;
            }
            if (state.selected_series && state.selected_series != -1) {
                apiParams.series_id = state.selected_series;
            }
            let clearData = false;
            let MatchTipsUrlKey = CFG_MODULES.MATCH_INFO.route;
            let isMatchTipsPage = route.path && route.path.includes(MatchTipsUrlKey.replace(/\//g, ''));
            if (isMatchTipsPage) { /* this block will remain here till football matchtips page available */
                let currSeries = getcurrentSeriesObj(state);
                if (
                    (state.selectedSport && state.selectedSport.id == 2) ||
                    // (currSeries && currSeries.sport_id == 2) || 
                    (state.selected_series && state.selected_series != -1 && !currSeries)
                ) {
                    clearData = true;// filter out football
                } else {
                    if (!currSeries) {
                        apiParams.sport_id = 1; // calling cricket data if it is matchtips without sport
                    }
                }
            }
            return startHTTPRequest({
                method: "GET",
                url: `${CFG_WIDGET_API_BASE}api/App/GetMatch_Tips_Predictions`,
                params: apiParams,
                can_append: false
            })
                .then((res) => {
                    if (isMatchTipsPage && !clearData) {
                        /* check is data loaded for football in series specific pages */
                        if (res && res.matches && res.matches.length) {
                            if (res.matches[0].sport_name.toLowerCase() === "football") {
                                clearData = true;
                            }
                        }
                    }

                    if (clearData) {
                        commit(SET_MATCH_TIPS_LISTING, {
                            count: 0,
                            matches: [],
                            isMobile: rootState.ismobile
                        });
                    } else {
                        commit(SET_MATCH_TIPS_LISTING, {
                            count: (res.count || 0),
                            matches: (res.matches || []),
                            isMobile: rootState.ismobile
                        });
                    }
                })
                .catch((e) => {
                    commit(SET_MATCH_TIPS_LISTING, {
                        count: 0,
                        matches: [],
                        isMobile: rootState.ismobile
                    });
                    console.log(e);
                    console.log(e.toString());
                });
        },
    }
}
export default serieslist;
